import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconFeather: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-outlined-radius-3-stroke-1.5-IconFeather"><Path d="M4.75 21.25C4.75 12.8054 7.81189 4.36086 16.698 2.78935C18.3899 2.49014 19.8093 3.94796 19.0312 5.44309C17.6673 8.06393 14.9611 9.80959 14.9611 9.80959L15.3435 10.0871C16.4025 10.8556 16.842 12.2048 16.1028 13.2713C14.7169 15.2708 11.6627 18.1299 5.52834 18.1299" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/></CentralIconBase>;
});

export default IconFeather;
